
export function curry(func: any, ...args) {
    return function (...newargs) {
        return func(...args, ...newargs);
    };
}

export function rightCurry(func, ...args) {
    return function (...newargs) {
        return func(...newargs, ...args);
    }
}
/**
 Hängt zwei Funktionen hintereinander
 compose(f1, f2)(arg) = f1(f2(arg))
 d.h. Funktionen weiter hinten im compose Aufruf sind weiter innen
 */
export function compose(...functions) {
    return function (...args) {
        if (functions.length === 0) {
            return undefined;
        }
        let result = functions[functions.length - 1](...args);
        for (let i = functions.length - 2; i > -1; i--) {
            result = functions[i](result);
        }
        return result;
    }
}

export function autocurry(func) {

    return function (...args) {
        if (func.length <= args.length) {
            return func(...args);
        }
        return curry(func, ...args);
    }
}

export const repeatAdditiv = autocurry(
    function(times, func, funcValue="", currentValue="", currentIteration=0) {
        if(currentIteration >= times) {
            return currentValue;
        }
        return repeatAdditiv(times, func, funcValue, currentValue + func(funcValue), currentIteration+1)
    }
);

export const negate = (f)=>compose(a=>!a, f);
